<div class="tab-pane show active fade details-view-results" id="trial-sites" role="tabpanel">
  <div class="details-view-results-head">
    <app-search-input name="searchInput" [parentForm]="searchForm"
      (inputChange)="onSearchInputChanged($event)"></app-search-input>
      <app-button text="+ Assign CMS User" variant="info" size="sm" (clicked)="onShowAssignCmsUserModal()" />
  </div>

  <table aria-hidden="true" class="details-view-sites with-heading-columns cms-users">
    <thead>
      <tr>
        <th>Name</th>
        <th>Email Address</th>
        <th style="text-align: center; min-width: 90px">Project<br />Manager</th>
        <th style="text-align: center; min-width: 90px;">Designated<br />Contact</th>
        @if (shouldShowEndpointDataEditor()) {
          <th style="text-align: center; min-width: 90px;">Endpoint<br />Data Editor</th>
        }
        <th style="text-align: center;">Countries</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of getCmsUsersForPage(currentPage); let i = index">
        <td> {{ user.name}}</td>
        <td> {{ user.email }}</td>
        <td style="text-align: center;">
          <app-trial-role-toggle [checked]="user.projectManager"
            (changed)="onRoleToggled(user.id, $event, user.designatedContact, user.endpointDataEditor, user.allCountries, user.countries)"></app-trial-role-toggle>
        </td>
        <td style="text-align: center;">
          <app-trial-role-toggle [checked]="user.designatedContact"
            (changed)="onRoleToggled(user.id, user.projectManager, $event, user.endpointDataEditor, user.allCountries, user.countries)"></app-trial-role-toggle>
        </td>
        @if (shouldShowEndpointDataEditor()) {
          <td style="text-align: center;">
            @if (shouldShowEndpointDataEditorForUser(user)) {
              <app-trial-role-toggle [checked]="user.endpointDataEditor"
                                     (changed)="onRoleToggled(user.id, user.projectManager, user.designatedContact, $event, user.allCountries, user.countries)"></app-trial-role-toggle>
            }
          </td>
        }
        <td class="btns site-actions" style="text-align: center;">
          <app-button [text]="getEditCountriesButtonLabel(user)" variant="info" size="xs" (clicked)="showEditTrialAssignmentModal(user)" />
        </td>
        <td class="text-right">
          <div class="site-actions">
            <app-button text="Unassign" variant="info" size="xs" (clicked)="onUnassignCmsUser(user.id, user.name)" />
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="no-results inside" *ngIf="trialUsers === null || trialUsers.length == 0">
    <div class="inner">
      <div class="image">
        <img src="assets/img/no-results-illustration.png" alt="No results found" />
      </div>
      <div class="content">
        <h2>No Results Found</h2>
        <p>There are no CMS users assigned to this trial.</p>
      </div>
    </div>
  </div>

  <app-pagination [currentPage]="currentPage" [totalPageCount]="pageCount"
    (pageSelected)="onPageSelected($event)"></app-pagination>
</div>

<!-- Start: Unassign CMS user -->
<app-modal #unassignCmsUserModal customClassName="delete-site-modal">
  <div class="modal-header">
    <h2 class="modal-title">Unassign CMS User?</h2>
  </div>
  <div class="text-center modal-body">
    <div class="delete-modal-text">
      <p>Are you sure you want to unassign {{ deletingCmsUserName !== null ? deletingCmsUserName : '' }} from this
        trial?</p>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row" style="margin-bottom: 30px;">
      <div class="col-6">
        <app-button text="Cancel" variant="secondary" width="fill" (clicked)="unassignCmsUserModal.hide()" />
      </div>

      <div class="col-6">
        <app-button text="Yes, unassign" width="fill" [isBusy]="unassignInProgress" [disabled]="unassignInProgress" (clicked)="onConfirmUnassignCmsUser()" />
      </div>
    </div>
  </div>
</app-modal>
<!-- End: Unassign sites modal -->

<!-- Start: Assign CMS user -->
<app-modal #assignCmsUserModal>
  <form [formGroup]="assignCmsUserForm" (submit)="onSubmitAssignForm()">
    <div class="modal-header">
      <h2 class="modal-title">Assign CMS User?</h2>
    </div>
    <div class="text-center modal-body">
      <div class="form-group">
        <app-input-select [items]="filteredCmsUsers" inputPlaceholder="Select a CMS User..."
          (onFilter)="filterAssignableCmsUsers($event)" [parentForm]="assignCmsUserForm" controlName="cmsUserId"
          searchInputPlaceholder="Search for CMS Users..." [allowFiltering]="true"></app-input-select>
      </div>

      <div class="form-group">
        <app-input-multi-select [items]="countryOptions" inputPlaceholder="Select countries..."
          [parentForm]="assignCmsUserForm" controlName="countries" searchInputPlaceholder="Search for country..."
          [allowFiltering]="true" [allowSelectDeselect]="true"></app-input-multi-select>
      </div>

      <div class="form-group" style="text-align: left;">
        <label class="checkbox">
          <input type="checkbox" id="isProjectManager" formControlName="projectManager" value="false">
          <span></span>
        </label>
        <label class="checkbox-label" for="isProjectManager">Project Manager</label>
      </div>

      <div class="form-group" style="text-align: left;">
        <label class="checkbox">
          <input type="checkbox" id="isDesignatedContact" formControlName="designatedContact" value="false">
          <span></span>
        </label>
        <label class="checkbox-label" for="isDesignatedContact">Designated Contact<span
            class="helper-text">Expense/Travel Coordinators Only</span></label>
      </div>

        <div class="form-group" style="text-align: left;">
          <label class="checkbox">
            <input type="checkbox" id="isEndpointDataEditor" formControlName="endpointDataEditor" value="false">
            <span></span>
          </label>
          <label class="checkbox-label" for="isEndpointDataEditor">Endpoint Data Editor</label>
        </div>

      <div class="form-group" style="text-align: left;">
        <label class="checkbox">
          <input type="checkbox" id="allCountries" formControlName="allCountries" value="false">
          <span></span>
        </label>
        <label class="checkbox-label" for="allCountries">Assign administrator to all countries</label>
      </div>
    </div>
    <div class="modal-footer">
      <div class="row" style="margin-bottom: 30px;">
        <div class="col-6">
          <app-button text="Cancel" variant="secondary" width="fill" (clicked)="assignCmsUserModal.hide()" />
        </div>

        <div class="col-6">
          <app-button text="Assign" type="submit" width="fill" [disabled]=" assignCmsUserForm.invalid || assignCmsUserForm.get('processing').value" [isBusy]="assignCmsUserForm.get('processing').value" />
        </div>
      </div>
    </div>
  </form>
</app-modal>
<!-- End: Assign sites modal -->

<app-edit-trial-assignment #editTrialAssignment (assignmentUpdated)="handleUpdatedAssignment($event)"></app-edit-trial-assignment>
